import React, { createContext, useState, useContext, ReactNode } from 'react';

type NavBarContextProps = {
	children: ReactNode;
};

type NavOptions = 'Lists' | 'Locations';

type NavBarContextValue = {
	hovered: NavOptions | undefined;
	setHovered: (x: NavOptions | undefined) => void;
};

const NavBarContext = createContext<NavBarContextValue>(undefined);

export const NavBarContextProvider = ({ children }: NavBarContextProps) => {
	const [hovered, setHovered] = useState<NavOptions | undefined>();

	return (
		<NavBarContext.Provider value={{ hovered, setHovered }}>
			{children}
		</NavBarContext.Provider>
	);
};

export const useNavBarContext = () => {
	return useContext(NavBarContext);
};
